// extracted by mini-css-extract-plugin
export default {"PortfolioPage":"Portfolio_PortfolioPage__WF4hY","sectionHead":"Portfolio_sectionHead__FRbhA"};